import Glide from '@glidejs/glide'
// import "@glidejs/glide/src/assets/sass/glide.core.scss"
// import "@glidejs/glide/src/assets/sass/glide.theme.scss"

const Default = {
    type: 'carousel',
    perView: 1,
    focusAt: 'center',
    gap: 0,
    keyboards: true,
}

/**
 * Initialise le composant Slider
 * Sous le capot, ce composant utilise la librairie GlideJS
 */
class Slider {

    /**
     * Constructeur de la class
     * @param target    Element cible
     * @param options
     */
    constructor (target, options = {}) {
        this._target = target
        this._options = { ...Default, ...options}
        this._init()
    }

    /**
     * Initialisation du slider / carousel
     * @private
     */
    _init () {
        // console.log(this._options)
        this._glide = new Glide(this._target, {
            type: this._options.type,
            perView: this._options.perView,
            focusAt: this._options.focusAt,
            gap: this._options.gap,
            keyboards: this._options.keyboards
        })

        this._glide.mount()
    }
}

if(typeof window !== "undefined") {
    window.Slider = Slider
}

/**
 * Fonction d'initialisation des sliders
 */
export function initSlider () {
    document.querySelectorAll('[data-slider]').forEach(target => {
        new Slider(target, {
            type: target.getAttribute('data-type') ?? 'carousel',
            focusAt: target.getAttribute('data-focus-at') ?? 0,
            perView: target.getAttribute('data-per-view') ?? 1,
            gap: target.getAttribute('data-gap') ?? 0
        })
    })
}

export default Slider
